// import fb from "../../assets/fb.svg";
import x from "../../assets/x.svg";
import insta from "../../assets/insta.svg";
import logo from "../../assets/logo-white.svg";
import { Link } from "react-router-dom";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        
      <footer className="bg-primary text-black p-8  ">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center w-full">
          {/* Left Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2 ">
            <img src={logo} alt="Logo" className="" />
            </div>
            {/* Social Icons */}
            <div className="flex space-x-4 text-3xl mt-6">
              {/* <a href="#" aria-label="Facebook">
                <img src={fb} alt="facebook"></img>
              </a> */}
              <a href="https://x.com/tweezersapp?s=21&t=YU8zdTctPbtwCVBw3oySBw" aria-label="X (Twitter)">
              <img src={x} alt="X"></img>
              </a>
              <a href="https://www.instagram.com/tweezerspredicts/" aria-label="Instagram">
              <img src={insta} alt="Instagram"></img>

              </a>
            </div>
            <p className="text-sm mt-8">&copy; {currentYear} Tweezers. All rights reserved</p>
          </div>
  
          {/* Right Section */}
          <div className="space-y-2 mt-6 md:mt-0">
            <h3 className="font-bold text-lg flex items-center">
              <span className="w-4 h-4 bg-secondary inline-block mr-2"></span> Quick Links
            </h3>
            <ul className="space-y-5 mt-3 mb-12">
              <li><Link to={"/policies"} className="hover:underline">Privacy Policy & Terms of Use</Link></li>
            </ul>
          </div>
        </div>
      </footer>
    );
  }
  